module.exports = __webpack_public_path__ + "crm_static/img/icon_disable_64@2x.651965ef.png";